
const AyodejiGbeleyi = () => {

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
          Ayodeji Ariyo Gbeleyi
          </h2>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-8 font-sans text-gray-800">


        <div className="bg-black text-white p-6 md:p-10 mb-6 shadow-xl rounded-3xl">
          <p className="text-lg md:text-xl leading-relaxed font-medium italic">
          Ayodeji Gbeleyi, MBA (IESE), FCTI, FCA, is the Director-General of Nigeria's Bureau of Public Enterprises (BPE). With over 30 years of experience, he is a respected leader in public finance, infrastructure, investment, and public-private partnerships, having served in senior roles across both the public and private sectors.          </p>
        </div>
        <section>
          <div className="max-w-6xl mx-auto p-8 bg-white font-sans text-gray-700">
            <div className="flex flex-col md:flex-row gap-12">

              {/* Left Side: Image */}
              <div className="md:w-1/3">
                <div className="sticky top-24">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-700 to-yellow-400 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src="/images/deji.jpeg"
                      alt="Kings C. Akuma"
                      className="relative w-full h-auto object-cover rounded-2xl shadow-2xl border-4 border-white"
                    />
                  </div>

                  <div className="mt-8 p-6 bg-gray-50 rounded-2xl border border-gray-100">
                    <h4 className="text-xs font-black text-green-700 uppercase tracking-widest mb-4">Core Expertise</h4>
                    <div className="flex flex-wrap gap-2">
                      {['Investment Banking', 'Finance', 'Consulting', 'Accounting'].map(tag => (
                        <span key={tag} className="px-3 py-1 bg-white border border-gray-200 rounded-full text-[10px] font-bold text-gray-600">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side: Content */}
              <div className="md:w-2/3">
                {/* Name and Title */}
                <header className="mb-12">
                  <h1 className="text-4xl font-black text-black mb-6 uppercase tracking-tight">Biography</h1>
                  <div className="text-lg leading-relaxed space-y-6 text-gray-600 font-medium">
                    <p>
                    Ayodeji Gbeleyi, MBA(IESE), FCTI, FCA is the Director-General, Bureau of Public Enterprises (BPE) in Nigeria, the government agency responsible for the reform and optimization of public enterprises. He was previously the Managing Partner/CEO of GA Capital Limited a boutique Financial Advisory Firm. He is an award-winning Chartered Accountant, a Fellow of both the Institute of Chartered Accountants of Nigeria (ICAN) and the Chartered Institute of Taxation of Nigeria (CITN), an MBA Holder from the University of Navarra (IESE), Spain, Member, Chartered Institute of Directors (CIoD), and a registered Capital Market Operator by the Securities & Exchange Commission (SEC).                    
                    </p>
                    <hr className="border-gray-100 mb-12" />
                    <p>
                    An advisor on Public Finance Management, Project Finance, Regulatory Compliance Matters, and Public-Private Partnership (PPP) projects to both private and public sectors. He undertakes training and capacity building programmes and advocacy in the same space in addition to serving on the Governance and Oversight Boards of certain Privately-Owned Companies, Government Owned Enterprises, Publicly Quoted Companies and an Educational Institution.                    
                    </p>
                    <hr className="border-gray-100 mb-12" />
      
                    <p>
                    He was extensively involved in attracting much-needed Foreign Direct Investments into Nigeria. He led the Finance Team of Vmobile as the Chief Treasury Officer that spearheaded the deal negotiation culminating in the successful raising in 2005 of over US$1.1 Billion project finance - a blockbuster in the annals of Project Finance in Nigeria was voted the “Europe Middle East & Africa (EMEA) Telecoms Deal of the Year 2005” by Project Finance Magazine a publication of Euromoney Institutional Investor Plc, UK. He played a pivotal role in US$1 Billion investment in 2006 for the acquisition of 65% equity stake in Vmobile by Celtel International B.V.                    </p>
                    <hr className="border-gray-100 mb-12" />
      
                    <p>
                    A former Honourable Commissioner for Finance in the Lagos State Government Executive Council. The pioneer Director-General of the PPP Office, Lagos State - the industrial and commercial nerve centre of Nigeria accounting for circa 25% of national GDP. Chairman, Board of Directors, Northwest Quadrant Development Limited (Alaro City Development FZC in Lekki Free Zone). Previously Chairman, Board of Directors - Axa-Mansard Health Limited, Federal Mortgage Bank of Nigeria, and Yola Electricity Distribution Company Plc, and served as Member - BusinessDay Editorial Advisory Board, Council Member – Lagos Chamber of Commerce & Industry (LCCI), Chairman Board of Governors, Baptist College of Theology Lagos, Member - Board of Directors Volkswagen of Nigeria, Chairman - Board of Directors Lekki Concession Company Limited (LCC), Member - Statutory Board Audit Committee, Stanbic-IBTC Bank Plc, Director - Med-view Airline Plc, Chairman - Lagos State Mortgage Board (LagosHOMS), Chairman, Board - Development Office, College of Medicine (University of Ibadan), and Member - Lagos Innovation Council.                    </p>
                    <hr className="border-gray-100 mb-12" />
                  </div>
                </header>


              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AyodejiGbeleyi;